import * as React from 'react';

import gql from 'graphql-tag';

import Grade from 'bundles/degree-home/components/course-section/Grade';
import ProgressIcon from 'bundles/degree-home/components/course-section/ProgressIcon';
import type { ComputedOutcome, ComputedProgress } from 'bundles/degree-home/types/Course';
import { isGradedItemOutcome } from 'bundles/degree-home/types/Course';

type Props = {
  typeName: string;
  isOverdue: boolean;
  computedProgress: ComputedProgress;
  computedOutcome?: ComputedOutcome;
};

class ProgressIndicator extends React.Component<Props> {
  static fragment = gql`
    fragment ProgressIndicatorFragment on DegreeLearnerProgressesV1_org_coursera_degree_learner_ItemState {
      ...ProgressIconFragment
    }
    ${ProgressIcon.fragment}
  `;

  render() {
    const { typeName, isOverdue, computedProgress, computedOutcome } = this.props;
    const isSplitForPeerReview = typeName === 'splitPeerReviewItem';
    const isPassed =
      computedOutcome &&
      computedOutcome.org_coursera_degree_learner_Outcome &&
      isGradedItemOutcome(computedOutcome.org_coursera_degree_learner_Outcome) &&
      computedOutcome.org_coursera_degree_learner_Outcome.isPassed;

    // hide the progress indicator for isSplitForPeerReview items in all other cases.
    // when the item is passed, show the progress icon
    if (isSplitForPeerReview && !isPassed) {
      return null;
    }

    return (
      <div className="rc-ProgressIndicator horizontal-box align-items-absolute-center">
        <ProgressIcon isOverdue={isOverdue} computedProgress={computedProgress} computedOutcome={computedOutcome} />

        {!isSplitForPeerReview && (
          <Grade isOverdue={isOverdue} computedProgress={computedProgress} computedOutcome={computedOutcome} />
        )}
      </div>
    );
  }
}

export default ProgressIndicator;
